import { api } from '@services/Api'
const adsApi = api.injectEndpoints({
    endpoints: (build) => ({
        postAdClick: build.mutation({
            query: (adId) => {
                const payload = {
                    'adId': adId
                };
                return {
                    url: `covr/v1/ads/click`,
                    method: "POST",
                    body: payload,
                };
            },
        }),
        postAdImpression: build.mutation({
            query: ([adId, count]) => {
                const payload = {
                    'adId': adId,
                    'count': count
                };
                return {
                    url: `covr/v1/ads/impression`,
                    method: "POST",
                    body: payload,
                };
            },
        }),
        getHeaderAds: build.query<any, any>({
            query: (args) => {
                const postId = args ? args.ID : 0;
                return {
                    url: `covr/v1/ads/header?postId=${postId}`,
                    method: "GET",
                };
            },
        })
    })
});

export const {
    usePostAdClickMutation,
    usePostAdImpressionMutation,
    useGetHeaderAdsQuery,
} = adsApi;